import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { lastValueFrom, map } from 'rxjs';
import {
  BfluenceIntegrityControllerService,
  BfluenceProblemGroupDetail
} from 'src/app/admin-api';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';
import { FormUtil } from 'src/app/utils/form.util';

@Component({
  selector: 'app-bfluence-integrity-dashboard',
  templateUrl: './bfluence-integrity-dashboard.component.html',
  styleUrl: './bfluence-integrity-dashboard.component.scss',
  providers: [DatePipe]
})
export class BfluenceIntegrityDashboardComponent implements OnInit {
  kpis: Array<BfluenceProblemGroupDetail> | undefined;
  data: any;
  options: any;

  constructor(
    private bfluenceIntegrityService: BfluenceIntegrityControllerService,
    private title: Title,
    private datePipe: DatePipe
  ) {
    this.title.setTitle('Dashboard Integridade Bfluence');
  }

  async ngOnInit(): Promise<void> {
    LoaderService.showLoader();
    await Promise.resolve(this.findKpis());
    LoaderService.showLoader(false);
  }

  async findKpis(): Promise<void> {
    try {
      this.kpis = await lastValueFrom(
        this.bfluenceIntegrityService.getBfluenceDashboard().pipe(
          map((data) =>
            data.result.map((g) => {
              g.viewName =
                g.viewName[0].toLowerCase() + g.viewName.substring(1);
              return g;
            })
          )
        )
      );
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    }
  }

  async refreshGroup(groupId: number): Promise<void> {
    try {
      LoaderService.showLoader();
      const kpis = await lastValueFrom(
        this.bfluenceIntegrityService.executeProblemKpi1(groupId).pipe(
          map((data) =>
            data.result.map((g) => {
              g.viewName =
                g.viewName[0].toLowerCase() + g.viewName.substring(1);
              return g;
            })
          )
        )
      );
      delete this.kpis;
      this.kpis = [...kpis];
      LoaderService.showLoader(false);
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    }
  }

  timeDiffLabel(dateStart: string): string {
    return FormUtil.timeDiffLabel(dateStart, this.datePipe);
  }

  timeLabel(dateStart: string): string | null {
    return this.datePipe.transform(
      FormUtil.utcDate(dateStart),
      'dd/MM/yyyy HH:mm:ss'
    );
  }
}
